module.exports = __webpack_public_path__ + "img/main.01700002.png";